export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-ashley-58972d14056a82b87542ce3e9e9fed92.jpg";